import type { WorkflowItem } from "../routes/microservices-processing"

function trimEnd(target: string, character: string) {
  return target.replace(new RegExp(`(${character})+$`, "g"), "")
}

export function getMessagePayload(payload: WorkflowItem["payload"]) {
  const { fileReference, FileReference, rsDocsWebAddress, rsDocsApiAddress } = payload

  return {
    hasFileReference: (fileReference ?? FileReference ?? "") !== "",
    docsUrl: [
      trimEnd(rsDocsWebAddress ?? "", "/"),
      payload.brand ?? payload.Brand,
      payload.caseReference ?? payload.CaseReference,
      payload.fileReference ?? FileReference,
    ].join("/"),
    metadataUrl: [
      trimEnd(trimEnd(rsDocsApiAddress ?? "", "/"), "api"),
      "api/metadata",
      payload.clientName ?? payload.ClientName,
      payload.brand ?? payload.Brand,
      payload.caseReference ?? payload.CaseReference,
      payload.fileReference ?? FileReference,
      "all",
    ].join("/"),
  }
}
